import { render, staticRenderFns } from "./SfScrollable.vue?vue&type=template&id=57b3f483"
import script from "./SfScrollable.vue?vue&type=script&lang=js"
export * from "./SfScrollable.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfScrollable.vue?vue&type=style&index=0&id=57b3f483&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "ce6ea79c"
  
)

export default component.exports